export class GMap {
    status: string;
    message: string;
    formatted_address: string;
    lat: number;
    lng: number;
    street_number: number;
    route: string;
    ward_id: number;
    ward: string;
    district_id: number;
    district: string;
    province_id: number;
    province: string;
    country: string;
    result: object;
}